// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HHf_","label":"styles_label__1JqNH"};